import { gql } from 'urql'

export const queryKapJournalsById = gql`
  query ($id: Int!) {
    kap_journal_by_pk(id: $id) {
      id
      title
      journal_date
      status
      description
      modules
      correspondence_between
    }
  }
`

export const queryKapJournalsPrimaryInfoByCantonCode = gql`
  query KapJournalsPrimaryInfoByCantonCode($canton_code: String!) {
    kap_journal(where: { canton_code: { _eq: $canton_code } }, order_by: [{ journal_date: desc }, { id: desc }]) {
      id
      title
      journal_date
      status
    }
  }
`

export const queryKapJournalsSecondaryInfoById = gql`
  query ($id: Int!) {
    kap_journal_by_pk(id: $id) {
      description
      modules
      correspondence_between
    }
  }
`
export const upsertKapJournalMutation = gql`
  mutation ($object: kap_journal_insert_input!) {
    insert_kap_journal_one(
      object: $object
      on_conflict: {
        constraint: kap_journal_pk
        update_columns: [title, journal_date, status, description, modules, correspondence_between]
      }
    ) {
      id
    }
  }
`

export const deleteKapJournalByIdMutation = gql`
  mutation ($id: Int!) {
    delete_kap_journal_by_pk(id: $id) {
      id
    }
  }
`

export const fetchKapJournalFileUUIDsQuery = gql`
  query ($kapJournalId: Int!) {
    file(where: { _and: { entity_id: { _eq: $kapJournalId }, entity_type: { _eq: "KAP_JOURNAL" } } }) {
      uuid
    }
  }
`
